import { useQuery } from "@tanstack/react-query";
import { Modal, Table } from "react-bootstrap";
import { getCardEvents, getToolOptions } from "../../api/tooling";
import { ApprovalBadge, ErrorNotice, dateLabel } from "./ToolingShared";

export default function CardAudit({
  id,
  onClose,
}: {
  id: number;
  onClose: () => void;
}) {
  const events = useQuery({
    queryKey: ["tooling", "events", id],
    queryFn: () => getCardEvents(id),
  });
  const options = useQuery({
    queryKey: ["tooling", "options"],
    queryFn: getToolOptions,
  });
  return (
    <Modal show onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Card #{id} · Change log</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ErrorNotice error={events.error} retry={() => events.refetch()} />
        {events.isLoading ? (
          <p>Loading changes…</p>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>Changed at</th>
                <th>Changed by</th>
                <th>Stage</th>
                <th>Points</th>
                <th>Die makers</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {events.data?.map((e) => (
                <tr key={e.id}>
                  <td>{dateLabel(e.created_at)}</td>
                  <td>{e.actor_name}</td>
                  <td>
                    {options.data?.statuses.find(
                      (s) => s.value === e.snapshot.status
                    )?.label || e.snapshot.status}
                  </td>
                  <td>
                    {e.snapshot.points}
                    <br />
                    <ApprovalBadge card={e.snapshot} />
                  </td>
                  <td>{e.snapshot.makers.map((m) => m.name).join(", ")}</td>
                  <td className="tooling-detail">{e.snapshot.detail}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}
